export default __webpack_public_path__ + "static/media/about.22d9cbd1.png";